import { createSlice } from '@reduxjs/toolkit'
import { createAxiosThunk } from 'utils/reduxUtil'
import api from 'api/axios/foka'
import { arrayEquals } from 'utils'

export const KeywordExtensionTypes = {
  keywordEx: 'keywordEx',
  segmentKeyword: 'segmentKeyword',
}
export const KeywordExtensionTypeNames = {
  keywordEx: '광고그룹 키워드확장',
  segmentKeyword: '광고그룹 분절 키워드',
}
const initialState = {
  type: KeywordExtensionTypes.keywordEx,
  visible: false,
  isSubmitting: false,
  previewVisible: false,
  isLoading: false,
  loadingError: undefined,
  adGroups: [],
  form: {
    keywordExtensionYn: 'N',
    exceptionKeywords: [],
  },
  preview: {
    keywordExtensionYn: 'N',
    exceptionKeywords: [],
  },
}

export const showAdGroupKeywordExtensionEdit = createAxiosThunk(
  'dashboard/showAdGroupKeywordExtensionEdit',
  ({ adGroupIds }) => api.ad.getAdGroups(adGroupIds)
)

export const updateAdGroupsKeywordExtension = createAxiosThunk(
  'dashboard/updateAdGroupsKeywordExtension',
  (noArgs, { getState }) => {
    const {
      adGroups,
      form: { keywordExtensionYn, exceptionKeywords },
    } = getState().dashboard.operation.adGroupKeywordExtensionEdit
    return api.ad.patchAdGroupsKeywordExtension({
      adGroupIds: adGroups.map(({ id }) => id),
      keywordExtensionYn,
      exceptionKeywords,
    })
  }
)
const adGroupKeywordExtensionEditSlice = createSlice({
  name: 'dashboard/adGroupKeywordExtensionEdit',
  initialState,

  reducers: {
    hideAdGroupKeywordExtensionEdit: () => initialState,
    setKeywordExtensionYn: (state, { payload }) => {
      state.form.keywordExtensionYn = payload
    },
    setExceptionKeywords: (state, { payload }) => {
      state.form.exceptionKeywords = payload
    },
    showPreview: state => {
      state.preview.keywordExtensionYn = state.form.keywordExtensionYn
      state.preview.exceptionKeywords = state.form.exceptionKeywords
      state.previewVisible = true
    },
    hidePreview: state => {
      state.previewVisible = false
    },
  },

  extraReducers: builder => {
    builder.addCase(
      showAdGroupKeywordExtensionEdit.pending,
      (
        state,
        {
          meta: {
            arg: { type = KeywordExtensionTypes.keywordEx },
          },
        }
      ) => {
        state.type = type
        state.isLoading = true
        state.visible = true
      }
    )

    builder.addCase(
      showAdGroupKeywordExtensionEdit.rejected,
      (state, { payload }) => {
        state.loadingError = payload
        state.isLoading = false
      }
    )

    builder.addCase(
      showAdGroupKeywordExtensionEdit.fulfilled,
      (state, { payload: { adGroupDtos } }) => {
        const adGroups = adGroupDtos.map(
          ({ id, name, keywordExtensionYn, exceptionKeywords }) => ({
            id,
            name,
            keywordExtensionYn,
            exceptionKeywords: exceptionKeywords
              ? exceptionKeywords.sort()
              : [],
          })
        )
        state.adGroups = adGroups
        const hasSameValue =
          adGroups.length > 1 &&
          adGroups.every(
            (value, index, array) =>
              value.keywordExtensionYn === array[0].keywordExtensionYn &&
              arrayEquals(value.exceptionKeywords, array[0].exceptionKeywords)
          )
        const hasSameYn =
          adGroups.length > 1 &&
          adGroups.every(
            (value, index, array) =>
              value.keywordExtensionYn === array[0].keywordExtensionYn
          )
        if (adGroups.length === 1 || hasSameValue) {
          const [first] = adGroups
          const { keywordExtensionYn, exceptionKeywords } = first
          state.form.keywordExtensionYn = keywordExtensionYn
          state.form.exceptionKeywords = exceptionKeywords
        }
        if (adGroups.length > 1 && !hasSameValue) {
          const [first] = adGroups
          const { keywordExtensionYn } = first
          state.form.keywordExtensionYn = hasSameYn ? keywordExtensionYn : 'Y'
        }
        state.visible = true
        state.isLoading = false
      }
    )

    builder.addCase(updateAdGroupsKeywordExtension.pending, state => {
      state.isSubmitting = true
    })

    builder.addCase(updateAdGroupsKeywordExtension.fulfilled, state => {
      state.isSubmitting = false
    })

    builder.addCase(updateAdGroupsKeywordExtension.rejected, state => {
      state.isSubmitting = false
    })
  },
})
export const {
  hideAdGroupKeywordExtensionEdit,
  showPreview,
  hidePreview,
  setKeywordExtensionYn,
  setExceptionKeywords,
} = adGroupKeywordExtensionEditSlice.actions
export default adGroupKeywordExtensionEditSlice.reducer
